function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a-toggle,.d-toggle{fill:none;}.a-toggle,.b-toggle{stroke:#fff;stroke-width:2px;}.a-toggle{stroke-linecap:round;}.b-toggle{fill:#25a14a;}.c-toggle{stroke:none;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-329.5 -188.924)"
}, /*#__PURE__*/React.createElement("line", {
  className: "a-toggle",
  y1: 15,
  transform: "translate(345.5 199.424) rotate(90)"
}), /*#__PURE__*/React.createElement("g", {
  className: "b-toggle",
  transform: "translate(338.102 202.924) rotate(-90)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "c-toggle",
  cx: 3.5,
  cy: 3.5,
  r: 3.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "d-toggle",
  cx: 3.5,
  cy: 3.5,
  r: 2.5
})), /*#__PURE__*/React.createElement("line", {
  className: "a-toggle",
  y2: 15,
  transform: "translate(345.5 192.424) rotate(90)"
}), /*#__PURE__*/React.createElement("g", {
  className: "b-toggle",
  transform: "translate(330.898 195.924) rotate(-90)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "c-toggle",
  cx: 3.5,
  cy: 3.5,
  r: 3.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "d-toggle",
  cx: 3.5,
  cy: 3.5,
  r: 2.5
})));

var SvgToggleIcon = function SvgToggleIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgToggleIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/toggle-icon.59285e86.svg";
export { ForwardRef as ReactComponent };